
export const SEGMENTATIONS = {
    HOUR: 'HourOfDay',
    DATE: 'Date',
    WEEK: 'Week',
    MONTH: 'Month',
    QUARTER: 'Quarter',
};


export const METRIC_SEGMENTATION_MAPPING = {
    [SEGMENTATIONS.DATE]: 'date',
    [SEGMENTATIONS.HOUR]: 'hourofday',
    [SEGMENTATIONS.WEEK]: 'week',
    [SEGMENTATIONS.MONTH]: 'month',
    [SEGMENTATIONS.QUARTER]: 'quarter_label',
};

export const API_DATE_FORMAT = 'YYYY-MM-DD';
